export const styleModalBoxProductos = (theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 54,
  pl: 2,
  pr: 2,
  pt: 2,
  pb: 2,
});
